export const m0l1Solution = `%lang starknet
// do not modify code on this line or above

from starkware.cairo.common.cairo_builtins import HashBuiltin

// Starknet provides a module management system.
// It is very similar to the Python's one.
// TODO: add the module imports needed to make the test pass!
// Help: for help check out this link to find the relevant import statement
// https://www.cairo-lang.org/docs/how_cairo_works/builtins.html#builtins

// do not modify code on this line or below

@external
func test_ok{syscall_ptr : felt*, pedersen_ptr : HashBuiltin*, range_check_ptr}() {
    return ();
}`;
